import React from 'react';
import { usePaymentStatusModalStore } from '@/store/usePaymentStatusModalStore';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { WarningModal } from '@/components/Ad/WarningModal';
import { useResponsive } from '@/hooks/useResponsive';

export const SuccessPaymentStatusModal = () => {
  const [isOpen, setIsOpen, paymentData] = usePaymentStatusModalStore(state => [
    state.isSuccessPaymentModalOpen,
    state.setIsSuccessPaymentModalOpen,
    state.successPaymentModalData,
  ]);
  const { isDesktop } = useResponsive();
  const { title, subtitle, iconName } = paymentData || {};

  function onClose() {
    setIsOpen(false);
  }

  return (
    <WarningModal
      dataTestId={AdPageTestIds.popup.success}
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? ''}
      description={subtitle}
      icon={`${iconName}.svg`}
      iconWidth={isDesktop ? 30 : 21}
      iconHeight={isDesktop ? 26 : 18}
      hasIconBg
    />
  );
};
